import { useEffect, useState } from "react";
import axios from "axios";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import Workspace from "./pages/Workspace";
import Login from "./pages/Login";
import { api } from "./lib/api";

function App() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const id = axios.interceptors.response.use((r) => r, (e) => {
      if (e.response?.status === 401 && !e.config?.url?.includes("/auth/login")) setUser(false);
      return Promise.reject(e);
    });
    api.me().then(setUser).catch(() => setUser(false));
    return () => axios.interceptors.response.eject(id);
  }, []);
  return (
    <>
      <Toaster position="top-right" richColors />
      {user === null ? null : user ? <Workspace user={user} onLogout={() => setUser(false)} /> : <Login onLogin={setUser} />}
    </>
  );
}

export default App;
